enum BooksitoutProductStatus {
    PLANNED,
    STARTED,
    GIVE_UP,
    RELEASED,
    PRODUCTION,
}

export default BooksitoutProductStatus